import { render, staticRenderFns } from "./sub-center-top.vue?vue&type=template&id=1791d238&scoped=true"
import script from "./sub-center-top.vue?vue&type=script&lang=js"
export * from "./sub-center-top.vue?vue&type=script&lang=js"
import style0 from "./sub-center-top.vue?vue&type=style&index=0&id=1791d238&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1791d238",
  null
  
)

export default component.exports